import React from "react";
import MyPosition from "./MyPosition";
import Top20Position from "./Top20Position";

export default function Leaderboard() {
  return (
    <>
      <MyPosition />

      <div className="my-8">
        <h3 className="text-lg font-bold">Top 20 Result</h3>
        <Top20Position />
      </div>
    </>
  );
}
